module.exports = __webpack_public_path__ + "img/client_registry_step.26254378.png";